export default __webpack_public_path__ + "static/media/gallery-wip-3d-print_01.0a60aaaa.jpg";